import * as React from 'react';
import * as _ from "lodash";
import { Button, Grid, Dropdown, Popup, Icon } from 'semantic-grab-ui/src';
import { getNodePopupContent } from 'omega-rtc/utils/trident-node-utils';
import { Campaign } from 'types/ts/campaigns';
import { nodeTypes } from 'data/trident-types';
import { getDefaultNodeName } from 'omega-rtc/utils/trident-node-utils';

interface ScenarioWidgetProps {
  model: Campaign,
  currentNodeKey: string,
  clickedNode: string,
  subScenarioIndex: number,
  handleNodePreview: Function,
  isFirstSubScenario?: boolean, // set to true if it's the first sub scenario in a chained scenario
}

export default class SubScenarioWidget extends React.Component<ScenarioWidgetProps> {
  render() {
    const {currentNodeKey, clickedNode, model, subScenarioIndex} = this.props;
    const subScenarios = _.get(model, `nodes.${currentNodeKey}.data.scenarios`, []);
    const nameSuffix = subScenarios.length > 1 ? `-${subScenarioIndex+1}` : '';
    const defaultName = `${getDefaultNodeName(currentNodeKey, nodeTypes.scenarios, _.get(model, 'nodesOccMap'))}${nameSuffix}`;

    let buttonStyle = {
      width: 104,
      height: 104,
      borderRadius: 104 / 2,
      border: '1px solid #ffc069',
      backgroundColor: '#fef2ea',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      marginLeft: 0,
      marginTop: 0,
    };
    if (clickedNode === currentNodeKey) { // node is clicked
      buttonStyle = {
        ...buttonStyle,
        border: '1px solid #fb9323',
        backgroundColor: '#fdd594',
      }
    }
    if (this.props.isFirstSubScenario) {
      buttonStyle = {
        ...buttonStyle,
        marginTop: 15,
      };
    }

    return (
      <Popup
        trigger={
          <span>
            <Button style={buttonStyle} onClick={() => this.props.handleNodePreview([currentNodeKey], currentNodeKey, subScenarioIndex)}>
              {_.get(model.nodes[currentNodeKey], `data.scenarios[${subScenarioIndex}].name`, defaultName) || defaultName}
            </Button>
          </span>
        }
        content={getNodePopupContent(model, `data.scenarios[${subScenarioIndex}].name`, currentNodeKey, defaultName)}
      />
    )
  }
}
